import React from 'react';
import { App } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { PropriedadesDeNotificacao } from '@/Utils/Notificacoes';

import { PerfilService, useListarPerfis } from '@/Services/Sistema/PerfilService';
import { PerfilFormBasic } from './PerfilFormBasic';
import { TypePerfil } from '@/Models/Pessoa/Perfil';
import AjudaComDropdown from '@/Components/Ajuda';

import * as Tutorial from "./perfil.tutorial"

export const PerfilForm: React.FC<{
    codigo?: number;
    aoCancelar?: () => void;
    depoisDeFinalizar?: () => void
}> = (props) => {

    const { notification } = App.useApp();

    const estaEditando = props.codigo != undefined;

    const inserir = useMutation({
        mutationFn: (perfil: TypePerfil) => PerfilService.inserir(perfil),
        onSuccess: () => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Cadastro realizado com sucesso."),
            });

            props.depoisDeFinalizar?.();
        },
    });

    const atualizar = useMutation({
        mutationFn: (perfil: TypePerfil) => PerfilService.atualizar(perfil),
        onSuccess: () => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Cadastro atualizado com sucesso."),
            });

            props.depoisDeFinalizar?.();
        },
    });

    const aoFinalizar = (perfil: TypePerfil) => {
        if (estaEditando) {
            atualizar.mutate(perfil);
        } else {
            inserir.mutate(perfil);
        }
    };

    return (
        <React.Fragment>
            <PerfilFormBasic
                codigo={props.codigo}
                txtBtnSalvar={estaEditando ? "Atualizar" : undefined}
                aoFinalizar={aoFinalizar}
                aoCancelar={props.aoCancelar}
                habilitarTutoriais
            />

            <AjudaComDropdown
                tutoriais={[
                    {
                        titulo: props.codigo ? "Como atualizar um perfil?" : "Como cadastrar um perfil?",
                        tutorial: Tutorial.AdicionarPerfil,
                    },
                ]}
            />
        </React.Fragment>
    );
};